import { Box, Button, Icon, useTheme, CircularProgress } from '@mui/material';

interface IFerramentasDaListagemProps {
  aoClicarEmFaturamento?: () => void;
  aoClicarEmNFE?: () => void;
  aoClicarEmNFCE?: () => void;
  desabilitarFaturamento?: boolean;
  desabilitarNFE?: boolean;
  desabilitarNFCE?: boolean;
  isLoading?: boolean;
}

export const FerramentasDaListagemFaturamento: React.FC<IFerramentasDaListagemProps> = ({
  aoClicarEmFaturamento,
  aoClicarEmNFE,
  aoClicarEmNFCE,
  desabilitarFaturamento = false,
  desabilitarNFE = false,
  desabilitarNFCE = false,
  isLoading = false,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.25 }}>
      <Button
        size="small"
        color="primary"
        variant="contained"
        disableElevation
        disabled={desabilitarFaturamento || isLoading}
        onClick={aoClicarEmFaturamento}
        startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <Icon>receipt_long</Icon>}
        sx={{
          fontWeight: 700,
          textTransform: 'none',
          borderRadius: 2,
          px: 2.5,
        }}
      >
        {isLoading ? 'Processando...' : 'Faturar'}
      </Button>

      <Button
        size="small"
        color="success"
        variant="contained"
        disableElevation
        disabled={desabilitarNFE || isLoading}
        onClick={aoClicarEmNFE}
        startIcon={<Icon>description</Icon>}
        sx={{
          fontWeight: 700,
          textTransform: 'none',
          borderRadius: 2,
          px: 2.5,
        }}
      >
        Emitir Nota Fiscal Eletrônica NFE
      </Button>

      <Button
        size="small"
        variant="contained"
        disableElevation
        disabled={desabilitarNFCE || isLoading}
        onClick={aoClicarEmNFCE}
        startIcon={<Icon>point_of_sale</Icon>}
        sx={{
          fontWeight: 700,
          textTransform: 'none',
          borderRadius: 2,
          px: 2.5,
          bgcolor: theme.palette.info.main,
          color: '#fff',
          '&:hover': { bgcolor: theme.palette.info.dark },
        }}
      >
        Emitir Cupom Fiscal NFC-e
      </Button>
    </Box>
  );
};
